import { LoadingState } from "./types";

const initialState = {
  sellers: [],
  sellersMap: {},
  loading: LoadingState.unset,
};

export function sellersReducer(state = initialState, action) {
  switch (action.type) {
    case "SELLERS_FETCH_DATA_SUCCESS":
      return {
        ...state,
        ...action.data,
      };
    case "SELLERS_FETCH_DATA_LOADING":
      return {
        ...state,
        ...action.data,
      };
    case "SELLERS_MAP_CREATION_SUCCESS":
      return {
        ...state,
        sellersMap: action.data,
      };
    default:
      return state;
  }
}
